<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('vincular-campanha') }}
                        </h1>
                    </div>
                    <div class="header-buttons">
                        <button class="delete-btn" type="button" @click="onFecharModal">
                            {{ $t('cancelar') }}
                        </button>
                        <button
                            v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-5">
                            <vss-select
                                :id="generateId(1)"
                                ref="campanhaSelect"
                                :options="campanhaSelect"
                                v-model="campanhaSelected"
                                class="no-clear"
                                :required="true"
                                title="campanha"
                                :invalid="!campanhaSelected"
                                :disabled="isUpdate"
                                :loading="loadingCampanha"
                                searchable
                                @search="loadCampanha"
                            />
                        </div>
                        <div class="column is-5">
                            <vss-select
                                :id="generateId(2)"
                                ref="tabprecoSelect"
                                :options="tabprecoSelect"
                                v-model="tabprecoSelected"
                                class="no-clear"
                                :required="true"
                                title="tabelapreco"
                                :invalid="!tabprecoSelected"
                                :loading="loadingTabpreco"
                                searchable
                                @search="loadTabpreco"
                            />
                        </div>
                        <div class="column is-2">
                            <vss-select
                                :id="generateId(3)"
                                ref="situacaoSelect"
                                :options="statusSelect"
                                v-model="statusSelected"
                                class="no-clear"
                                :required="true"
                                title="situacao"
                                :invalid="!statusSelected"
                                :disabled="!isUpdate"
                            />
                        </div>
                        <div class="column is-5">
                            <v-input
                                :id="generateId(4)"
                                ref="valorInput"
                                v-model="campanhaproduto.valor"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="valor"
                                msg="msg-campo-obrigatorio"
                                :invalid="!campanhaproduto.valor"
                                uppercase
                                required
                                v-mask="['#######']"
                            />
                        </div>
                        <div class="column is-5">
                            <v-input
                                :id="generateId(5)"
                                ref="valorMinimoInput"
                                v-model="campanhaproduto.valorminimo"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="valorminimo"
                                msg="msg-campo-obrigatorio"
                                :invalid="!campanhaproduto.valorminimo"
                                uppercase
                                required
                                v-mask="['#######']"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AssCampanhaProdutoService from '@/services/vendas/produto/AssCampanhaProdutoService';
import VenProdutoService from '@/services/vendas/produto/VenProdutoService';
import AssProdutoEmpresaService from '@/services/vendas/empresa/abas/AssProdutoEmpresaService';
import CampanhaProdutoValidation from '@/services/validations/vendas/produto/CampanhaProdutoValidation';
import Message from '@/models/Message';

export default {
    props: {
        idProduto: 0,
        idcampanhaproduto: 0,
    },
    data() {
        return {
            service: new AssCampanhaProdutoService(this.$http, this.$router),
            serviceTabpreco: new VenProdutoService(this.$http, this.$router),
            serviceEmpresa: new AssProdutoEmpresaService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            campanhaproduto: {
                idcampanhaproduto: null,
                idcampanha: null,
                idtabpreco: null,
                idproduto: null,
                valor: null,
                valorminimo: null,
                situacao: null,
            },
            isUpdate: false,
            statusSelected: { id: 1, label: this.$t('ativo') },
            statusSelect: [
                { id: 0, label: this.$t('inativo') },
                { id: 1, label: this.$t('ativo') },
            ],
            tabprecoSelect: [],
            tabprecoSelected: null,
            empresas: [],
            campanhaSelect: [],
            campanhaSelected: null,
            column: 'descricao',
            order: 'desc',
            validation: new CampanhaProdutoValidation(this.msgs),
            loadingCampanha: false,
            loadingTabpreco: false,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'produtos', 'campanhas');

        if (!this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'campanha' },
            });
        }
        if (this.idcampanhaproduto > 0) {
            this.isUpdate = true;
            this.carregarDados();
        } else {
            this.loadCampanha();
            this.loadEmpresas();
        }
    },
    methods: {
        carregarDados() {
            this.isLoading = true;
            this.service
                .getById(this.idcampanhaproduto)
                .then((body) => {
                    this.campanhaproduto = {
                        idcampanhaproduto: this.idcampanhaproduto,
                        idcampanha: body.content.idcampanha,
                        idtabpreco: body.content.idtabpreco,
                        idproduto: body.content.idproduto,
                        valor: body.content.valor,
                        valorminimo: body.content.valorminimo,
                        situacao: body.content.situacao,
                    };
                    this.campanhaSelected = {
                        id: body.content.idcampanha,
                        label: body.content.descricaocampanha,
                    };
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados: ', e);
                })
                .finally(() => {
                    this.isLoading = false;
                    this.loadEmpresas();
                });
        },
        loadCampanha(search = '') {
            this.loadingCampanha = true;
            this.service
                .findCampanhasNaoAssociadosProduto(
                    this.column,
                    this.order,
                    0,
                    20,
                    this.idProduto,
                    search
                )
                .then(this.mapCampanha)
                .then((value) => {
                    this.campanhaSelect = value;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally((_) => {
                    this.loadingCampanha = false;
                });
        },
        loadEmpresas() {
            this.loadingTabpreco = true;
            this.serviceEmpresa
                .findByIdProduto(
                    this.column,
                    this.order,
                    0,
                    20,
                    3,
                    this.idProduto,
                    this.queryFilter
                )
                .then(this.mapEmpresa)
                .then((value) => {
                    this.empresas = value;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally((_) => {
                    this.loadTabpreco();
                });
        },
        loadTabpreco(search = '') {
            let empresas = '0, ';
            for (let e of this.empresas) {
                empresas += `${e.id}, `;
            }
            empresas = empresas.slice(0, -2);
            this.serviceTabpreco
                .loadPreco(this.idProduto, empresas, this.column, this.order, 0, 20, 3, search)
                .then(this.mapTabpreco)
                .then((value) => {
                    this.tabprecoSelect = value;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally((_) => {
                    if (this.isUpdate) {
                        this.tabprecoSelected = this.tabprecoSelect.filter((e) => {
                            return e.id == this.campanhaproduto.idtabpreco;
                        })[0];
                    }
                    this.loadingTabpreco = false;
                });
        },
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        save() {
            this.campanhaproduto = this.mapTosave(this.campanhaproduto);
            this.campanhaproduto.idproduto = this.idProduto;
            this.campanhaproduto.idcampanha = this.campanhaSelected
                ? this.campanhaSelected.id
                : null;
            this.campanhaproduto.idtabpreco = this.tabprecoSelected
                ? this.tabprecoSelected.id
                : null;
            this.campanhaproduto.situacao = this.statusSelected.id;
            if (this.validation.validate(this.campanhaproduto, this.$refs)) {
                this.isSaving = true;
                this.service
                    .save(this.campanhaproduto)
                    .then((body) => {
                        if (body.content) {
                            let msg = 'msg-campanhaproduto-salvo';
                            if (this.campanhaproduto.id) {
                                msg = 'msg-campanhaproduto-edit';
                            }
                            this.campanhaproduto = body.content;
                            this.msgs.push(new Message('success', msg, true));
                        } else {
                            if (this.$t(body.message)) {
                                this.msgs.push(new Message('alert', body.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                        this.msgs.push(new Message('error', 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                        this.onFecharModal();
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        mapCampanha(body) {
            return body.content.map((m) => {
                return {
                    id: m.idcampanha,
                    label: m.descricao,
                    datavalidade: m.datavalidade,
                };
            });
        },
        mapTabpreco(body) {
            return body.content.map((m) => {
                return {
                    id: m.tabpreco.idtabpreco,
                    label: m.tabpreco.descricao,
                };
            });
        },
        mapEmpresa(body) {
            return body.content.map((m) => {
                return {
                    id: m.empresa.idempresa,
                    label: m.empresa.rsocial,
                };
            });
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
